<template>
  <div class="discovery-page">
      <div class="explain-page">
        <div class="font-area" :class="globalTransition">
          <div class="explain font-blue">
            <p>{{$t('discoveryPage.title')}}</p>
          </div>
          <div class="line font-blue">——</div>
          <div class="title font-blue">
            <p>{{$t('discoveryPage.p1.p1')}}<br>
            {{$t('discoveryPage.p1.p2')}}</p>
          </div>
          <div class="content font-gray">
            <p>{{$t('discoveryPage.p2.p1')}}<br>
           {{$t('discoveryPage.p2.p2')}}<br>
            {{$t('discoveryPage.p2.p3')}}</p></div>
        </div>
        <div>
          <img :src="discoveryIconGroupUrl" class="discovery-icon-group" alt="LOGO">
        </div>
      </div>
    <div class="explain-page bg1 font-white">
      <div class="font-area" :class="globalTransition">
        <div class="explain">
          <p>{{$t('discoveryPage2.title')}}</p>
        </div>
        <div class="line">——</div>
        <div class="title">
          <p>{{$t('discoveryPage2.p1.p1')}}<br>
         {{$t('discoveryPage2.p1.p2')}}</p>
        </div>
        <div class="content">
          <p>{{$t('discoveryPage2.p2.p1')}}<br>
         {{$t('discoveryPage2.p2.p2')}}</p>
          <p>{{$t('discoveryPage2.p2.p3')}}<br>
        {{$t('discoveryPage2.p2.p4')}}</p>
          <p>{{$t('discoveryPage2.p2.p5')}}<br>
          {{$t('discoveryPage2.p2.p6')}}<br>
         {{$t('discoveryPage2.p2.p7')}}</p>
        </div>
      </div>
    </div>
    <div class="show-page3">
        <img :src="discoveryBG2Url" class="left-img">
        <div class="right">
          <div class="title" :class="globalTransition">
            <p :class="language" >{{$t('discoveryPage3.title')}}</p>
          </div>
          <div class="p1" :class="globalTransition"
               :style="language==='en'?'display:none':''">
            <p>{{$t('discoveryPage3.p1.p1')}}<br>
              {{$t('discoveryPage3.p1.p2')}}</p>
          </div>
          <div class="p2"
               :class="globalTransition" >
            <p>{{$t('discoveryPage3.p2.p1')}}</p>
            <p :style="language==='zh'?'display:none':''">{{$t('discoveryPage3.p2.p2')}}</p>
            <p :style="language==='zh'?'display:none':''">{{$t('discoveryPage3.p2.p3')}}</p>
          </div>
        </div>
  </div>
    <footMenu class="foot-menu"></footMenu>
  </div>
</template>

<script>
import discoveryIconGroup from '@/assets/discoveryIconGroup.png';
import discoveryBG2 from '@/assets/discoveryPageBG2.jpg';
import footMenu from '@/components/footMenu';

export default {
  name: 'discoveryPage',
  components: {
    footMenu,
  },
  data() {
    return {
      discoveryIconGroupUrl: discoveryIconGroup,
      discoveryBG2Url: discoveryBG2,
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
  },
};
</script>

<style lang="scss" scoped>
  .discovery-icon-group{
    width: 75%;
    margin-top: 2rem;
  }
  .bg1{
background-image: url("../../assets/discoveryPageBG1.jpg");
    background-repeat:no-repeat;
    background-size:100% 100%;
  }
  .show-page3{
    padding: 7.5rem 6.7%;
    background-color: #fff;
    display: flex;
    height: 54rem;
    .left-img{
      height: 100%;
      width: 50%;
    }
    .right{
      height: 100%;
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #369ff6;
      .title{
        padding-left: 6rem;
          font-weight: 600;
          font-size: 1.8rem;
          p { margin-block-start: 0em!important;}
        }
      .p1{
        padding-left: 6rem;
          font-size: 3.6rem;
          line-height: 5rem;
          font-weight: bolder;
          p { margin-block-start: 3rem!important;
            margin-block-end: 3rem!important;
          }
        }
        .p2{
          background-color: #E9F5FF;
          color: #444;
          width: 100%;
          height: 70%;
          padding: 0 6rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 2rem;
          font-size: 1.2rem;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/discoveryPage/index.vue